import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.jpg';

const SocialProof = () => {
    return (
        <section id="dokazi" className="py-24 flex items-center justify-center bg-black">
            <div className="max-w-6xl mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="flex flex-col items-center justify-center"
                >
                    <div className="relative w-full max-w-[500px] aspect-[3/2] overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 via-black to-gray-900 border border-white/5 shadow-2xl shadow-blue-500/5 items-center justify-center flex p-8 md:p-12">
                        <img
                            src={logo}
                            alt="Eagle AI Agents Logo"
                            className="max-w-full max-h-full object-contain hover:scale-105 transition-transform duration-700 filter drop-shadow-2xl"
                        />
                    </div>
                    <div className="mt-8 text-center">
                        <h3 className="text-xl md:text-2xl font-bold tracking-widest uppercase opacity-80 text-white">
                            Eagle AI Automatizacija
                        </h3>
                        <div className="w-12 h-1 bg-blue-600/50 mx-auto mt-4 rounded-full" />
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default SocialProof;
